<template>
  <div class="product bps" v-bind:class="{contrasted: isPageContrasted, fontBigger: isFontBigger}">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" data-aos="fade-up" v-if="lang === 'pl'">Bird Protection System - przełomowa technologia ochrony ptaków na farmach wiatrowych, pozwalająca na zrównoważony rozwój energetyki </div>
        <div class="heading-text" data-aos="fade-up" v-if="lang !== 'pl'">Bird Protection System - a disruptive technology for bird protection at wind farms, allowing for sustainable wind and power development</div>
        <p data-aos="fade-up" data-aos-delay="100"></p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p data-aos="fade-up" data-aos-delay="200"></p>
        <div class="btn-hover">
          <router-link to="/products/farms/presentation" class="btn orange" data-aos="fade-up" data-aos-delay="250">
            {{$t('component.watchPresentation')}}<span/></router-link>
        </div>
        <div
          class="btn-hover"
          @click="$modal.show('video-static')"
        >
          <div class="btn orange" data-aos="fade-up" data-aos-delay="250">{{$t('component.watchVideo')}}<span/></div>
        </div>
      </div>
    </header>

    <div id="top" class="why-us-solution">
      <div class="elements">
        <div class="element bps clearfix">
          <div class="text-box">
            <ul v-if="lang === 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
              Celem projektu jest opracowanie w pełni dostosowanego do potrzeb rynku rozwiązania do wykrywania  i odstraszania ptaków w okolicy farm wiatrowych.  Ze względu na wysokie ryzyko kolizji z ptakami, niektóre z istniejących farm są zmuszone do wyłączenia turbin. Opracowaliśmy pierwotną wersję systemu do wykrywania ptaków i wprowadzania odpowiedniej reakcji, która sprawdziła się w działaniu. Obecnie w pełni rozumiemy problemy dotyczące awifauny na farmach wiatrowych i pragniemy opracować w pełni automatyczne i bardzo precyzyjne rozwiązanie, które w znacznym stopniu ograniczy liczbę kolizji, a także straty właścicieli turbin. Opracowane w ramach projektu rozwiązanie będzie charakteryzować się:
            <br/>
                  <br /> 1.  Zwiększoną dokładnością klasyfikacji obiektów oraz minimalną liczbą fałszywych detekcji. W tym celu zastosujemy samouczące się algorytmy bazujące na sztucznej inteligencji oraz paradygmacie Big Data w rozproszonym systemie IoT.
                  <br /> 2. Wysoką niezawodnością systemu. Nowa metoda autodiagnostyki i in-situ auto-kalibracji umożliwi na skrócenie czasu instalacji oraz ich długą żywotność.
                  <br /> 3. Otwartą elastyczną architekturą systemu, która pozwoli na łatwe skalowanie produktu i jego kastomizację.
                </span>
              </li>
              <li>
                <span class="text">
                  <br/><br/><br/>
                Wartosć projektu:<br/>
                3 866 129,08PLN
                  <br/><br/>
                  Dofinansowanie projektu z UE:<br/>
                2 890 434.62PLN
                  <br/><br/>
                  Okres realizacji: 01.09.2021 – 31.08.2023
                </span>
              </li>
            </ul>
            <ul v-if="lang !== 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
                The aim of the project is to develop solutions to meet the needs of the bird advisory and deterrent market in the vicinity of wind farms. We have noticed that wind farms development poses a threat to local environment, especially avifauna. Even some of the existing power plants have been obliged to shut down turbines due to the high risk of collision with birds. We developed the initial detection and deterrence system that has been proved to be of high value. Currently, we fully understand the problems regarding avifauna on wind farms and wish to develop a fully automatic and very precise solution that will largely reduce the number of collisions, as well as wind farm owners’ losses.
In this project our goal is to develop a market-tailored bird protection solution that will be characterised by:
                <br/>
                  <br/> 1.  Improved object classification accuracy, which will reduce the number of false positive detections. We will implement
a self-adapting artificial intelligence algorithms and methods based on paradigm of big data in a large-scale IoT distributed
system.
                  <br/> 2. Low acquisition system uncertainty, which also affects robustness. A regular in situ auto-calibration method is crucial
to ensure high system efficiency and long product lifetime.
                  <br/> 3. An open flexible architecture of the system that can be adapted to particular customer’s requirements.
                </span>
              </li>
              <li>
                <span class="text"><br/><br/><br/>
                Project value:<br/>
                   3 866 129,08PLN
                  <br/><br/>
                 Amount of founding from UE:<br/>
                2 890 434.62PLN
                  <br/><br/>
                  Period of implementation: 01.09.2021 – 31.08.2023
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import VideoBox from '../components/VideoBox';
  import Counter from '../components/Counter';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'farms-product',
    components: {
      FooterMain,
      FooterMoreInformation,
      VideoBox,
      Counter
    },
    data: function () {
      return {
        circleValues: [
          {
            before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
          },
        ]

      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      isPageContrasted(){
        return store.state.isPageContrasted
      },
      isFontBigger(){
        return store.state.isPageFontBigger
      },
      smoothScroll: () => smoothScroll
    },

    methods: {},
    mounted: function () {
      store.state.isAccessibilityVisible = true;
    },
    destroyed: function () {
      store.state.isAccessibilityVisible = false;
    },
  }
</script>

<style>
  .bps header.page-header .heading-text {
    max-width: 1200px !important;
  }

  .product .why-us-solution .elements .element.bps .text-box {
    float: left;
    max-width: initial;
    margin-top: 20px;
    margin-bottom: 100px;
  }

  .product .why-us-solution .elements .element.bps .text-box ul li .text {
    margin-top: -20px;
  }


  .ue{
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    text-align: center;
  }

  .ue img{
    max-width: 940px;
    width: 35%;
  }

  .product.contrasted{
    background: #000;
    color: yellow;
  }

  .product.contrasted .heading-text{
    color: yellow;
  }
  .product.contrasted .ue{
    background: #000;
  }

  .product.contrasted header a{
    color: yellow;
    background: #000;
  }
  .product.contrasted .btn{
    color: yellow;
    background: #000;
  }
  .product.fontBigger .why-us-solution .elements .element .text-box ul li .text{
    font-size: 1.6em;
    line-height: 1.6em;
  }


</style>



// WEBPACK FOOTER //
// BPS2.vue?7c170cbc